import type { AudioSchemaType, AudioFontSchemaType } from '@vedalib/editor/lib/brand'
import type { VideoSchemaType, VideoFontSchemaType } from '@vedalib/editor/lib/brand'
import type {
  AudioElementValue,
  EditorElement,
  VideoElementValue,
} from '@vedalib/editor/lib/elements'

import type {
  FCDemoType,
  FCElementType,
  FCFormValueType,
  BrandFormsMapType,
  FCFormBrandType,
} from '../../elements.types'

export type MediaDemoType = FCDemoType<
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType
>

export type MediaEditorElement = EditorElement<
  AudioElementValue | VideoElementValue,
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType
>

export type MediaElementType = FCElementType<
  AudioElementValue | VideoElementValue,
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  MediaState
>

export type MediaFormValueType = FCFormValueType<
  AudioElementValue | VideoElementValue,
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  MediaState
>

export type MediaFormBrandType = FCFormBrandType<
  AudioElementValue | VideoElementValue,
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  MediaState
>

export type MediaBrandForms = BrandFormsMapType<
  AudioElementValue | VideoElementValue,
  AudioSchemaType | VideoSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  AudioFontSchemaType | VideoFontSchemaType,
  MediaState
>

export enum VideoPointActionUiEnum {
  EDIT = 'EDIT',
  REMOVE = 'REMOVE',
}

export type MediaState = {
  duration: number
  originalDuration: number
  maxPlayedSeconds?: number
}
